/* TM Gewährleistungslabel: Badge in den Footer verschieben + Overlay.
   Zusätzlich: Sticky-ATC-Fix – Footer bekommt unten so viel Abstand, wie die fixe Sticky-Add-to-Cart-Leiste hoch ist,
   damit Copyright + Label auf Mobile nicht verdeckt werden. */
(function () {
  function bind(w) {
    if (w.__tmBound) return;
    w.__tmBound = true;
    var sel = w.getAttribute('data-tm-lgb-target');
    var t = sel ? document.querySelector(sel) : null;
    if (t) t.insertBefore(w, t.firstChild);
    var dlg = w.querySelector('dialog'),
      btn = w.querySelector('.tm-lgb__btn'),
      img = w.querySelector('.tm-lgb__full');
    if (!dlg || !btn || !img) return;
    function open() {
      if (!img.getAttribute('src')) img.setAttribute('src', img.getAttribute('data-src'));
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else window.open(img.getAttribute('data-src'), '_blank');
    }
    btn.addEventListener('click', open);
    var c = w.querySelector('[data-tm-lgb-close]');
    if (c) c.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }
  var tries = 0;
  function boot() {
    tries++;
    var ws = document.querySelectorAll('.tm-lgb');
    var pending = false;
    ws.forEach(function (w) {
      var sel = w.getAttribute('data-tm-lgb-target');
      if (sel && !document.querySelector(sel) && tries < 40) { pending = true; return; }
      bind(w);
    });
    if (pending) setTimeout(boot, 150);
  }

  /* Sticky-ATC-Fix */
  var footer = null, lastPad = -1, ticking = false;
  function stickyHeight() {
    var h = 0;
    document.querySelectorAll('.dbtfy-addtocart-sticky, .dbtfy-toast-container').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.bottom >= window.innerHeight - 4) h = Math.max(h, window.innerHeight - r.top);
    });
    return h;
  }
  function applyPad() {
    ticking = false;
    footer = footer || document.querySelector('.dbtfy-footer');
    if (!footer) return;
    var h = stickyHeight();
    var pad = h > 0 ? Math.round(h + 12) : 0;
    if (pad !== lastPad) { footer.style.paddingBottom = pad ? pad + 'px' : ''; lastPad = pad; }
  }
  function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(applyPad); } }
  function stickyInit() {
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    setInterval(schedule, 1000);
    schedule();
  }

  function start() { boot(); stickyInit(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
